  document.addEventListener('DOMContentLoaded', function () {
    var splide = new Splide('#splide__brand_slide', {
      type      : 'loop',
      perPage   : 4,
      perMove   : 1,
      pagination: false,
      arrows    : false,
      autoplay  : false,    // AutoScroll runs independently
      drag      : 'free',   // Free dragging enabled
      gap       : '2rem',
      autoScroll: {
        speed        : 1,    // Adjust speed here (1 is slow, increase for faster)
        pauseOnHover : true, // Pause autoScroll when mouse hovers
        pauseOnFocus : true, // Pause autoScroll when slider gets focus
        rewind      : false, // Don't rewind; keep scrolling continuously
      },
      breakpoints: {
        1024: { perPage: 4 },
        768 : { perPage: 3 },
        480 : { perPage: 2 },
      },

    });
    splide.mount(window.splide.Extensions);
  });

document.addEventListener('DOMContentLoaded', function () {
  var splide = new Splide('.brands_logo2', {
    type      : 'loop',
    perPage   : 6,
    perMove   : 1,
    pagination: false,
    arrows    : false,
    autoplay  : false,    // AutoScroll runs independently
    drag      : 'free',   // Free dragging enabled
    gap       : '2rem',
    autoScroll: {
      speed        : 1,    // Adjust speed here (1 is slow, increase for faster)
      pauseOnHover : true, // Pause autoScroll when mouse hovers
      pauseOnFocus : true, // Pause autoScroll when slider gets focus
      rewind      : false, // Don't rewind; keep scrolling continuously
    },
    breakpoints: {
      1024: { perPage: 4 },
      768 : { perPage: 3 },
      480 : { perPage: 2 },
    },
  });

  // Mount AutoScroll extension with the main splide instance
  splide.mount(window.splide.Extensions);
});


